<template>
  <div id="invoice" class="container">
    <a-page-header class="header" title="电子发票" />
    <div class="invoice-wrap">
      <div class="block invoice-form">
        <a-form
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-item label="凭证类型">
            <a-select
              placeholder="凭证类型"
              v-decorator="[
                'idType',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'change',
                },
              ]"
              size="large"
            >
              <a-select-option
                v-for="license in licenseOptions"
                :key="license.value"
                :value="license.value"
              >
                {{ license.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="凭证号码">
            <a-input
              placeholder="请输入所选凭证类型号码"
              v-decorator="[
                'certNo',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
            />
          </a-form-item>
          <a-form-item label="旅客姓名">
            <a-input
              placeholder="请输入您客票上显示的姓名"
              v-decorator="[
                'passengerName',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
            />
          </a-form-item>
          <a-form-item label="手机号码">
            <a-input
              placeholder="请输入手机号码"
              v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
            />
          </a-form-item>
          <a-form-item label="验证码">
            <l8-imgcaptcha
              v-decorator="[
                'captcha',
                {
                  rules: [{ validator: handleFieldValidate }],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
              @blur="onCaptchaChange"
            ></l8-imgcaptcha>
          </a-form-item>
          <a-form-item label="手机验证码">
            <l8-mobileverification
              :countryCode="countryCode"
              :phone="phone"
              :captcha="phoneCaptcha"
              v-model="validateCode"
              :size="'large'"
              v-decorator="[
                'phoneCode',
                {
                  rules: [{ validator: handleFieldValidate }],
                  validateTrigger: 'blur',
                },
              ]"
            ></l8-mobileverification>
          </a-form-item>
          <a-form-item label :wrapper-col="{ span: 16, offset: 6 }">
            <a-button
              type="primary"
              class="submit-btn"
              size="large"
              @click="formSubmit"
              >验证信息</a-button
            >
          </a-form-item>
        </a-form>
      </div>
      <div
        class="block invoice-notice"
        v-if="invoiceValidTips"
        v-html="invoiceValidTips"
      ></div>
    </div>
  </div>
</template>
<script>
import { validate } from '@/assets/js/validate'
import Storage from '@/assets/js/storage'
import getAppInfo from '@/utils/from'
import { getCertTypes } from '@/apis/invoice'
import './index'

export default {
  data () {
    return {
      form: this.$form.createForm(this),
      countryCode: '86',
      validateCode: '', // 手机验证码
      phone: '', // 发送手机验证码的手机号码
      phoneCaptcha: false, // 手机号码校验结果
      ticketCode: getAppInfo()?.ticketCode,
      licenseOptions: [],
      list: [],
      invoiceValidTips: ''
    }
  },
  created () {
    this.getCmsData()
    this.fetchCertTypes()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then((res) => {
          const { content } = res?.invoiceValidTips
          this.invoiceValidTips = content || ''
        })
      } catch (err) {}
    },
    async fetchCertTypes () {
      try {
        this.licenseOptions = await getCertTypes() || []
        if (this.licenseOptions.length) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              idType: this.licenseOptions[0].value
            })
          })
        }
      } catch (err) {
        this.$message.error(err.message || '查询失败，请稍后再试')
      }
    },
    onCaptchaChange (value) {
      this.phoneCaptcha = !!value
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      validate('invoice-valid', formValues, rule.fullField).then(
        ({ valid, errors }) => {
          if (rule.fullField === 'phone') {
            this.phone = formValues.phone
          }
          if (valid) {
            callback()
          } else {
            callback(errors[0].message)
          }
        }
      )
    },
    formSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            certType: values.idType,
            currentPageNumber: 1,
            pageSize: 1000
          }

          delete params.idType
          Storage.setItem('ordersInvoiceParams', JSON.stringify(params), 6 * 60 * 60 * 1000)
          this.$router.push({ path: '/invoice/book' })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#invoice {
  ::v-deep .ant-form-explain {
    margin-top: 0;
  }
  .header {
    border-bottom: 1px solid @primary-color;
  }
  .invoice-wrap {
    padding: 70px 0;
    display: flex;
    .block {
      padding: 0 40px;
      width: 50%;
    }
    .invoice-form {
      border-right: 1px solid #eee;
    }
    .submit-btn.ant-btn {
      width: 100%;
    }
  }
}
</style>
